import api from './api'

const networkService = {
  /**
   * Get all networks
   */
  getNetworks: async () => {
    const response = await api.get('/networks')
    return response.data
  },

  /**
   * Get a specific network
   */
  getNetwork: async (id) => {
    const response = await api.get(`/networks/${id}`)
    return response.data
  },

  /**
   * Create a new network
   */
  createNetwork: async (data) => {
    const response = await api.post('/networks', data)
    return response.data
  },

  /**
   * Update a network
   */
  updateNetwork: async (id, data) => {
    const response = await api.put(`/networks/${id}`, data)
    return response.data
  },

  /**
   * Delete a network
   */
  deleteNetwork: async (id) => {
    const response = await api.delete(`/networks/${id}`)
    return response.data
  },

  /**
   * Invite a profile to a network
   */
  inviteToNetwork: async (networkId, data) => {
    const response = await api.post(`/networks/${networkId}/invite`, data)
    return response.data
  },

  /**
   * Accept a network invitation
   */
  acceptInvite: async (inviteId) => {
    const response = await api.put(`/invites/${inviteId}/accept`)
    return response.data
  },

  /**
   * Decline a network invitation
   */
  declineInvite: async (inviteId) => {
    const response = await api.put(`/invites/${inviteId}/decline`)
    return response.data
  },

  /**
   * Subscribe to a network
   */
  subscribe: async (networkId, profileId) => {
    const response = await api.post(`/networks/${networkId}/subscribe`, { profile_id: profileId })
    return response.data
  },

  /**
   * Unsubscribe from a network
   */
  unsubscribe: async (networkId, profileId) => {
    const response = await api.post(`/networks/${networkId}/unsubscribe`, { profile_id: profileId })
    return response.data
  },
}

export default networkService
